import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import { useState, useMemo } from "react";
import Link from "next/link";
import useBlogs from "@/hooks/useBlogs";
import useEvents from "@/hooks/useEvent";
import usePodcasts from "@/hooks/usePodcast";
import SearchIcon from "@/assets/Search.svg";
import CloseIcon from "@/assets/Close.svg";

export const ResourcesHero = ({ title, subtitle, className }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const blogs = useBlogs({ limit: null });
  const events = useEvents({ limit: null });
  const podcasts = usePodcasts({ limit: null });
  const allResources = useMemo(() => {
    if (!blogs || !events || !podcasts) return [];

    const formattedBlogs = blogs.map((item) => ({ ...item, type: "Blog", slug: `/blogs/${item.url_slug}` }));
    const formattedEvents = events.map((item) => ({ ...item, type: "Event", slug: `/events/${item.url_slug}` }));
    const formattedPodcasts = podcasts.map((item) => ({ ...item, type: "Podcast", slug: `/podcast/${item.url_slug}` }));

    return [...formattedBlogs, ...formattedEvents, ...formattedPodcasts];
  }, [blogs, events, podcasts]);

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.length > 2) {
      const filteredResults = allResources.filter((item) => item.title.toLowerCase().includes(query.toLowerCase()));
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  };

  return (
    <section className={cn(styles.ResourcesHero, className)}>
      <Container className={styles.inner}>
      <div className={styles.searchContainer}>
  <SearchIcon className={styles.searchIcon} />
  <input
    type="text"
    placeholder="Search by keywords"
    className={styles.searchInput}
    value={searchQuery}
    onChange={handleSearch}
  />
  <CloseIcon
    className={styles.closeIcon}
    onClick={() => setSearchQuery("")}
  />
</div>

        <div className={styles.layout}>
          <div className={styles.menu}>
            <div className={styles.jumpLabel}>JUMP TO</div>
            <div className={styles.menuList}>
              <a href="#blogs" className={styles.menuItemActive}>
                Blogs
              </a>
              <a href="#events" className={styles.menuItem}>
                Events
              </a>
              <a href="#podcasts" className={styles.menuItem}>
                Podcasts
              </a>
            </div>
          </div>
          <div className={styles.main}>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {title && <h2 className={styles.title}>{title}</h2>}
          </div>
        </div>

        {searchQuery.length > 2 && (
          <div className={styles.resultsContainer}>
            {searchResults.length > 0 ? (
              searchResults.map((item) => (
                <Link href={item.slug} key={item.id} className={styles.resultItem}>
                  <div className={styles.resultTitle}>{item.title}</div>
                  <div className={styles.resultType}>{item.type}</div>
                </Link>
              ))
            ) : (
              <div className={styles.noResults}>No results found.</div>
            )}
          </div>
        )}
      </Container>
    </section>
  );
};

export default ResourcesHero;
